"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PivotTableColumnHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var icons_1 = require("@material-ui/icons");
var core_1 = require("@material-ui/core");
var Text_1 = require("../Text");
var Icon_1 = require("../Icon");
var icons_2 = require("../../icons");
var styles_1 = __importDefault(require("./styles"));
var PivotTableColumnHeader = function (_a) {
    var columnTitle = _a.columnTitle, isEditing = _a.isEditing, editField = _a.editField, editButtonHandler = _a.editButtonHandler, deleteButtonHandler = _a.deleteButtonHandler;
    var classes = (0, styles_1.default)();
    var _b = react_1.default.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var editToogleHandler = function () {
        editButtonHandler(!isEditing || false);
        handleClose();
    };
    var deleteHandler = function () {
        deleteButtonHandler();
        handleClose();
    };
    var open = Boolean(anchorEl);
    var id = open ? 'simple-popover' : undefined;
    return ((0, jsx_runtime_1.jsxs)(core_1.Paper, __assign({ elevation: 1, className: classes.headerCell, "data-testid": "table-column-header" }, { children: [!isEditing && (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.title }, { children: columnTitle })), isEditing && editField, !isEditing && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.columnMoreOptions }, { children: [(0, jsx_runtime_1.jsx)(core_1.Button, __assign({ "aria-describedby": id, onClick: handleClick, className: classes.moreButton }, { children: (0, jsx_runtime_1.jsx)(icons_1.MoreVert, {}) })), (0, jsx_runtime_1.jsx)(core_1.Popover, __assign({ id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }, transformOrigin: {
                            vertical: 'top',
                            horizontal: 'center',
                        } }, { children: (0, jsx_runtime_1.jsxs)(core_1.List, { children: [(0, jsx_runtime_1.jsxs)(core_1.ListItem, __assign({ dense: true, button: true, onClick: editToogleHandler }, { children: [(0, jsx_runtime_1.jsx)(core_1.ListItemIcon, __assign({ className: classes.menuIcon }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, __assign({ isSelected: true, color: "rgba(0, 0, 0, 0.54)" }, { children: (0, jsx_runtime_1.jsx)(icons_2.Rename, {}) })) })), (0, jsx_runtime_1.jsx)(core_1.ListItemText, { children: (0, jsx_runtime_1.jsx)(Text_1.Text, { children: "Edit" }) })] })), (0, jsx_runtime_1.jsxs)(core_1.ListItem, __assign({ dense: true, button: true, onClick: deleteHandler }, { children: [(0, jsx_runtime_1.jsx)(core_1.ListItemIcon, __assign({ className: classes.menuIcon }, { children: (0, jsx_runtime_1.jsx)(icons_1.Delete, {}) })), (0, jsx_runtime_1.jsx)(core_1.ListItemText, { children: (0, jsx_runtime_1.jsx)(Text_1.Text, { children: "Delete" }) })] }))] }) }))] })))] })));
};
exports.PivotTableColumnHeader = PivotTableColumnHeader;
